/**
* @file 系统设置-短信管理
* */
<template>
  <div id="sms">
    <tab-frame :tabs="tabs"></tab-frame>
  </div>
</template>

<script>
  export default {
    name: "sms",
    data () {
      return {
        // tabs列表
        tabs: [
          {label: '优惠券管理', name: '/coupon'},
          {label: '领取使用情况', name: '/couponReceiving'}
        ]
      }
    }
  }
</script>

<style lang="less">

</style>
